/* @flow */
// typecheck: ignore file
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import AnnouncementComposer from 'groups/components/AnnouncementComposer.jsx';
import Group from 'entities/Group';
import GroupStore from 'groups/stores/GroupStore';
import Message from 'entities/Message';
import RoleBasedMessagingRecipientsInput from 'chat/components/RoleBasedMessagingRecipientsInput.jsx';
import {
  selectGroup,
} from 'reducers/roleBasedMessagingSearch';
import type { Target } from 'entities/Message';

import './styles/RoleBasedMessagingComposer.scss';


export class RoleBasedMessagingComposer extends React.Component {
  props: {
    onSelectGroup: (group: Group) => mixed,
    initialMessage: Message,
    onMessageSent?: (targets: Target[]) => void,
    charLimit: number,
    charLimitWithFiles: number,
    targets: Target[],
    onRequestHide: () => void,
    isEdit?: bool,
  };

  state: {
    inComposer: bool,
  };

  state = {
    inComposer: false,
  };

  static childContextTypes = {
    eventScreenName: React.PropTypes.string,
  };

  getChildContext() {
    return {
      eventScreenName: 'role_based_messaging_composer',
    };
  }

  componentWillMount() {
    const { initialMessage, onSelectGroup } = this.props;
    if (initialMessage &&
        (initialMessage.getThreads().length || initialMessage.getTargets().length)) {
      this.setState({ inComposer: true });
    } else if (initialMessage && initialMessage.getGroupIds().length) {
      initialMessage.getGroupIds().forEach(groupId => onSelectGroup(GroupStore.getGroup(groupId)));
      initialMessage.set('group_ids', []);
      this.setState({ inComposer: true });
    }
  }

  handleInputFocus = () => {
    if (this.state.inComposer) {
      this.setState({ inComposer: false });
    }
  }

  goToComposer = () => {
    if (!this.state.inComposer) {
      this.setState({ inComposer: true });
    }
  }

  render() {
    const { initialMessage } = this.props;
    let initialTargets;

    if (initialMessage && initialMessage.getThreads().length) {
      initialTargets = initialMessage.getThreads();
    } else if (initialMessage && initialMessage.getTargets().length) {
      initialTargets = initialMessage.getTargets();
    }

    return (
      <div className="RoleBasedMessagingComposer">
        <RoleBasedMessagingRecipientsInput
          className="RoleBasedMessagingComposer-recipients-input"
          autoFocus={!this.state.inComposer}
          onInputFocus={this.handleInputFocus}
          initialTargets={initialTargets || []}
          onEnter={this.goToComposer}
          onActionButtonClick={this.goToComposer}
          hideResults={this.state.inComposer}
        />
        {this.state.inComposer &&
          <AnnouncementComposer
            className="RoleBasedMessagingComposer-composer-container"
            initialMessage={initialMessage}
            onMessageSent={this.props.onMessageSent}
            charLimit={this.props.charLimit}
            charLimitWithFiles={this.props.charLimitWithFiles}
            targets={this.props.targets}
            onRequestHide={this.props.onRequestHide}
            hideOldInput
            autoFocus
            isEdit={this.props.isEdit}
          />
        }
      </div>
    );
  }
}

const mapStateToProps = (state: Object) => {
  return {
    targets: state.roleBasedMessagingSearch.targets,
  };
};

const mapDispatchToProps = (dispatch: Function) =>
  bindActionCreators({
    onSelectGroup: selectGroup,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RoleBasedMessagingComposer);



// WEBPACK FOOTER //
// ./src/chat/components/RoleBasedMessagingComposer.jsx